var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.192 28C8.928 28 8.688 27.88 8.52 27.688C7.656 26.704 0 17.992 0 13.192C0 8.128 4.128 4 9.192 4C14.256 4 18.384 8.128 18.384 13.192C18.384 17.968 10.728 26.704 9.864 27.688C9.696 27.88 9.456 28 9.192 28ZM9.192 5.824C5.136 5.824 1.824 9.136 1.824 13.192C1.824 16.36 6.648 22.672 9.192 25.696C11.736 22.696 16.56 16.36 16.56 13.192C16.56 9.136 13.248 5.824 9.192 5.824Z",
    fill: "url(#paint0_linear_348_6427)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.19199 17.9199C6.64798 17.9199 4.58398 15.8559 4.58398 13.3119C4.58398 10.7679 6.64798 8.70386 9.19199 8.70386C11.736 8.70386 13.8 10.7679 13.8 13.3119C13.8 15.8559 11.736 17.9199 9.19199 17.9199ZM9.19199 10.5279C7.65599 10.5279 6.40799 11.7759 6.40799 13.3119C6.40799 14.8479 7.65599 16.0959 9.19199 16.0959C10.728 16.0959 11.976 14.8479 11.976 13.3119C11.976 11.7759 10.728 10.5279 9.19199 10.5279Z",
    fill: "url(#paint1_linear_348_6427)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_348_6427",
    x1: 0,
    y1: 4,
    x2: 23.1718,
    y2: 21.7496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEC163"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_348_6427",
    x1: 4.58398,
    y1: 8.70386,
    x2: 13.8,
    y2: 17.9199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEC163"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.e24264c7ec44ee8b73dd28f8c665aad4.svg";
export { ForwardRef as ReactComponent };